<template>
  <div class="home-index">
    <!-- 轮播图 -->
    <Carousel v-model="select" arrow="never" radius-dot :loop='banner&&banner.length>1'  :autoplay='banner&&banner.length>1'>
      <CarouselItem class="banner-big" v-for="(item) in banner" :key="item.bannerUrl">
        <!--?x-oss-process=image/resize,m_lfit,h_940,w_529/format,png-->
        <img class="img" :src="`${item.bannerUrl}?x-oss-process=image/resize,m_fixed,h_529,w_940/format,png`" @click="enterBrand(item)"/>
      </CarouselItem>
    </Carousel>
    <!-- 显示小图 -->
    <div class="banner-small">
      <img :src="`${small.bannerUrl}?x-oss-process=image/resize,m_lfit,h_940,w_529/format,png`" v-for="(small) in bannerSmall" :key="small.bannerUrl" @click="enterBrand(small)"/>
    </div>
  </div>
</template>

<script>
import { Carousel, CarouselItem } from 'iview';
import settingMixin from '@/mixins/setting';

export default {
  name: 'home-index',
  mixins: [
    settingMixin,
  ],
  components: {
    Carousel,
    CarouselItem,
  },
  data() {
    return {
      select: 0,
      banner: [],
      bannerEn: [],
      bannerSmall: [],
    };
  },
  created() {
    // this.getSetting();
    // banner
    this.$service.project.getWebSetting({ content: { type: 0 } })
      .then(() => {
        this.getCustomizedWebSettingByKeyId();
      });
  },
  methods: {
    // 获取项目设置
    getSetting() {
      const defaultBanners = [ // 默认的banner图配置
        {
          // 忽略使用require的eslint警告
          // eslint-disable-next-line
          bannerUrl: require('@/assets/image/banner/banner20230425.jpg'),
          jumpType: 0,
          jumpUrl: '',
          menuId: 0,
        },
      ];
      const {
        banner: banners = defaultBanners,
        bannerEn: bannerEn = defaultBanners,
      } = this.setting; // 解构赋值 如果没有获取到配置则设置默认值
      this.banner = banners;
      this.bannerEn = bannerEn;
      this.bannerSmall = [ // 默认小babber图
        {
          // eslint-disable-next-line
          bannerUrl: require('@/assets/image/banner/s-1.jpg'),
          jumpType: 0,
          jumpUrl: '',
          menuId: 0,
        },
        {
          // eslint-disable-next-line
          bannerUrl:require('@/assets/image/banner/s-2.jpg'),
          jumpType: 0,
          jumpUrl: '',
          menuId: 0,
        },
        {
          // eslint-disable-next-line
          bannerUrl:require('@/assets/image/banner/s-3.jpg'),
          jumpType: 0,
          jumpUrl: '',
          menuId: 0,
        },
      ];
    },
    getCustomizedWebSettingByKeyId() {
      this.getSetting();
      this.$service.user.getCustomizedWebSettingByKeyId({
        keyId: this.$service.project.setting.keyId,
      })
        .then((result) => {
          const rotationList = [];
          if (result.data) {
            if (result.data.rotationList && result.data.rotationList.length > 0) {
              result.data.rotationList.map((rotation) => {
                rotationList.push({
                  bannerUrl: rotation.picUrl,
                  ...rotation,
                });
                return rotationList;
              });
              this.banner = rotationList;
            }
            if (result.data.smallBannerList && result.data.smallBannerList.length > 0) {
              // const list = result.data.smallBannerList;
              // let itemData1 = [];
              // let itemData2 = [];
              // let itemData3 = [];
              // [itemData1, itemData2, itemData3] = list;

              // this.bannerSmall = [];

              result.data.smallBannerList.slice(0, 3).forEach((item, index) => {
                const banner = item;
                if (banner && banner.picUrl) {
                  banner.bannerUrl = banner.picUrl;
                  // this.bannerSmall.push(banner);
                  this.bannerSmall.splice(index, 1, banner);
                }
              });

              // if (itemData1 && itemData1.picUrl) {
              //   itemData1.bannerUrl = itemData1.picUrl;
              //   this.bannerSmall[0] = itemData1;
              // }
              // if (itemData2 && itemData2.picUrl) {
              //   itemData2.bannerUrl = itemData2.picUrl;
              //   this.bannerSmall[1] = itemData2;
              // }
              // if (itemData3 && itemData3.picUrl) {
              //   itemData3.bannerUrl = itemData3.picUrl;
              //   this.bannerSmall[2] = itemData3;
              // }
            }
          }
        });
    },
    enterBrand(item) {
      if (item.jumpType === 1) {
        if (item.jumpUrl) {
          window.open(item.jumpUrl);
        }
      } else if (item.jumpType === 2) {
        if (item.detailPicUrlList && item.detailPicUrlList.length > 0) {
          sessionStorage.setItem('picItem', JSON.stringify(item));
          this.$router.push('pic');
        } else if (item.productPrimaryTypeName) {
          sessionStorage.setItem('picItem', JSON.stringify(item));
          this.$router.push({
            path: '/booking/menu/default',
            query: {
              name: item.productPrimaryTypeName,
            },
          });
        }
      }
    },
  },
};

</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'

.home-index
  min-height: 300px
  @include base-wrap
  overflow: hidden
  .banner-big
    height: 410px
    cursor: pointer
    img
      width: 100%
  .banner-small
    display: flex
    justify-content: space-between
    margin: 14px 0
    img
      width: 304px
      cursor: pointer
</style>
